import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { OauthAEMConfig } from '../../../models';
import { DashboardResponse, EndpointKeys, IDP_APPS } from '../../../session';

@Injectable({
  providedIn: 'root'
})
export class UserDataService {
  errorHandler = handleError.bind(this);

  authConfigJson!: Observable<OauthAEMConfig>;

  constructor(private http: HttpClient, private appConfig: AppConfigService) {}

  getAuthConfigContent(): Observable<OauthAEMConfig> {
    if (this.authConfigJson) {
      return this.authConfigJson;
    } else {
      this.authConfigJson = this.getAuthConfig().pipe(shareReplay(1));
      return this.authConfigJson;
    }
  }

  getAuthConfig = (): Observable<OauthAEMConfig> => {
    return new ApiBuilder<undefined, OauthAEMConfig>(this.http, this.appConfig)
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeys.APP_AUTH_CONFIG_JSON)
      .method(HttpRequestMethods['GET'])
      .timeOut(10000)
      .errorHandler(this.errorHandler)
      .library('SHARED')
      .create();
  };

  private getDashBrdDataPayload(
    config: OauthAEMConfig,
    tokenResponse: string
  ): Record<string, string | number> {
    if (config.TOKEN_HEADER && config.ENABLE_NEW_PERSISTENT_LOGIN) {
      return {};
    } else if (config.ENABLE_NEW_PERSISTENT_LOGIN) {
      return { eamToken: tokenResponse };
    } else {
      return {};
    }
  }

  getDashBrdData = (
    config: OauthAEMConfig,
    tokenResponse: string
  ): Observable<DashboardResponse> => {
    const headers: HttpHeadersPayload = {
      'Content-Type': 'application/json'
    };

    if (tokenResponse && config.TOKEN_HEADER) {
      headers['Authorization'] = 'Bearer ' + tokenResponse;
    }

    return new ApiBuilder<Record<string, string | number>, DashboardResponse>(
      this.http,
      this.appConfig
    )
      .app(IDP_APPS.COMMON)
      .endpointKey(EndpointKeys['DASHBOARD_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .timeOut(config.LOGIN_TIMEOUT ? config.LOGIN_TIMEOUT : 10000)
      .payload(this.getDashBrdDataPayload(config, tokenResponse))
      .httpHeaders(headers)
      .errorHandler(this.errorHandler)
      .library('SHARED')
      .create();
  };
}
